import {
  filterPermittedActionsWithDividers,
  parseActionsOnValidDivider,
} from '../../utils/massActions'

import {
  PROVIDER_ACTION_ARCHIVE,
  PROVIDER_ACTION_ARCHIVE_MASS,
  PROVIDER_ACTION_EDIT_BUILDINGS_AND_CATEGORIES,
  PROVIDER_ACTION_EDIT_BUILDINGS_AND_CATEGORIES_MASS,
  PROVIDER_ACTION_MASS_EMAIL,
  PROVIDER_ACTION_RESTORE,
  PROVIDER_ACTION_RESTORE_MASS,
} from './Provider.constants'

export function getProviderTableMassActions(permissions, t) {
  const items = [
    {
      label: t('Providers.MassEditBuildingAndCategoryActionOptionKey'),
      permission: permissions.can_edit_mapping,
      value: PROVIDER_ACTION_EDIT_BUILDINGS_AND_CATEGORIES_MASS,
    },
    {
      label: t('Providers.MassMailingActionOptionKey'),
      permission: permissions.can_create_mass_mailing,
      value: PROVIDER_ACTION_MASS_EMAIL,
    },
    null,
    {
      label: t('Providers.ArchiveActionOptionKey'),
      permission: permissions.can_archive,
      value: PROVIDER_ACTION_ARCHIVE_MASS,
    },
    {
      label: t('Providers.RestoreActionOptionKey'),
      permission: permissions.can_restore,
      value: PROVIDER_ACTION_RESTORE_MASS,
    },
  ]

  return parseActionsOnValidDivider(filterPermittedActionsWithDividers(items))
}

export function getProviderTableNotificationTitle({
  action,
  count,
  t,
  totalCount,
}) {
  const types = {
    [PROVIDER_ACTION_ARCHIVE]: t('Notification.ProvidersTitleArchivedKey'),
    [PROVIDER_ACTION_ARCHIVE_MASS]: t(
      'Notification.ProvidersTitleMassArchivedKey',
      {
        count,
        totalCount,
      }
    ),
    [PROVIDER_ACTION_EDIT_BUILDINGS_AND_CATEGORIES]: t(
      'Notification.ProvidersTitleEditedMappingKey'
    ),
    [PROVIDER_ACTION_EDIT_BUILDINGS_AND_CATEGORIES_MASS]: t(
      'Notification.ProvidersTitleMassEditedMappingKey',
      {
        count,
        totalCount,
      }
    ),
    [PROVIDER_ACTION_MASS_EMAIL]: t(
      'Notification.ProvidersTitleMassMailingdKey',
      {
        count,
        totalCount,
      }
    ),
    [PROVIDER_ACTION_RESTORE]: t('Notification.ProvidersTitleRestoredKey'),
    [PROVIDER_ACTION_RESTORE_MASS]: t(
      'Notification.ProvidersTitleMassRestoredKey',
      {
        count,
        totalCount,
      }
    ),
  }

  return types[action] || null
}

export function getProviderTableItemActions({ item }) {
  const { permissions } = item

  const items = [
    {
      label: 'Providers.EditBuildingAndCategoryActionOptionKey',
      permission: permissions.can_edit_mapping,
      value: PROVIDER_ACTION_EDIT_BUILDINGS_AND_CATEGORIES,
    },
    null,
    {
      label: 'Providers.ArchiveActionOptionKey',
      permission: permissions.can_archive,
      value: PROVIDER_ACTION_ARCHIVE,
    },
    {
      label: 'Providers.RestoreActionOptionKey',
      permission: permissions.can_restore,
      value: PROVIDER_ACTION_RESTORE,
    },
  ]

  return parseActionsOnValidDivider(filterPermittedActionsWithDividers(items))
}

export function getProviderTableAsyncNotificationText({ action, t }) {
  const types = {
    [PROVIDER_ACTION_ARCHIVE_MASS]: t(
      'Notification.ProviderAsyncTextMassArchiveKey'
    ),
    [PROVIDER_ACTION_RESTORE_MASS]: t(
      'Notification.ProviderAsyncTextMassRestoreKey'
    ),
  }

  return types[action] || null
}
